import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ShopProvider } from "@/context/ShopContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import BusinessEnquiries from "@/pages/BusinessEnquiries";
import Shop from "@/pages/Shop";
import CommercialScenting from "@/pages/CommercialScenting";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Account from "@/pages/Account";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Info from "@/pages/Info";
import { PrivacyPolicy, Terms } from "@/pages/Legal";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <ShopProvider>
        <Toaster
          theme="light"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#f5ede2",
              border: "1px solid #d8ccbb",
              color: "#1a1a1a",
              fontFamily: "Montserrat, sans-serif",
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/commercial-scenting" element={<CommercialScenting />} />
            <Route path="/shop/:slug" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/account" element={<Account />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/enquiries" element={<BusinessEnquiries />} />
            <Route path="/contact" element={<Navigate to="/enquiries" replace />} />
            <Route path="/collection" element={<Navigate to="/shop" replace />} />
            <Route path="/vision" element={<Navigate to="/shop" replace />} />
            <Route path="/info" element={<Info />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </ShopProvider>
    </BrowserRouter>
  );
}

export default App;
